import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _includes from 'lodash/includes';
import PropTypes from 'prop-types';
// Models
import mSimcard from 'models/simcard';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import { AddTextButton } from 'components/buttons/TextButtons';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import GroupAddForm from './GroupAddForm';
import GroupItem from './GroupItem';

class GroupsManager extends React.Component {
  constructor(props) {
    super(props);

    this.handleAdd = this.handleAdd.bind(this);
    this.handleCancelAdd = this.handleCancelAdd.bind(this);
    this.handleValidateAdd = this.handleValidateAdd.bind(this);
    this.handleApnSelection = this.handleApnSelection.bind(this);

    this.state = {
      addFormVisible: false,
    };
  }

  // Handlers
  handleAdd(e) {
    e.preventDefault();
    this.setState({
      addFormVisible: true,
    });
  }

  handleCancelAdd() {
    this.setState({
      addFormVisible: false,
    });
  }

  handleValidateAdd(data) {
    const { onAddSimcardGroup } = this.props;
    onAddSimcardGroup(data);
    this.setState({
      addFormVisible: false,
    });
  }

  handleApnSelection(simcardGroup, apnId) {
    const {
      handleDisplayConfirm, onAddSimcardGroupApn, onDeleteSimcardGroupApn,
    } = this.props;
    if (!_includes(simcardGroup.apns, apnId)) {
      // An APN has been selected => add it to the group
      onAddSimcardGroupApn(simcardGroup.id, { apn_id: apnId });
    } else {
      // An APN has been unselected => display confirmation message
      handleDisplayConfirm(
        { id: 'confirm.deleteSimcardGroupApn' },
        () => onDeleteSimcardGroupApn(simcardGroup.id, { apn_id: apnId }),
        { additionalMessage: <strong><LocalizedMessage id="info.deleteSimcardGroupApnWarning" /></strong> },
      );
    }
  }

  render() {
    const { simcardGroups } = this.props;
    const { addFormVisible } = this.state;
    const sortedSimcardGroups = mSimcard.sortGroups(simcardGroups.elements.data);

    return (
      <LoadingDisplayer loading={simcardGroups.loading}>
        <div className="pt-3">
          {addFormVisible ? (
            <div>
              <GroupAddForm
                onCancel={this.handleCancelAdd}
                onValidate={this.handleValidateAdd}
              />
            </div>
          ) : (
            <div>
              <AddTextButton
                primary
                disabled={addFormVisible}
                onClick={this.handleAdd}
              />
            </div>
          )}
        </div>
        {!!sortedSimcardGroups && _map(sortedSimcardGroups, (simcardGroup) => (
          <div className="pt-3" key={_toString(simcardGroup.id)}>
            <GroupItem
              simcardGroup={simcardGroup}
              onApnSelection={this.handleApnSelection}
            />
          </div>
        ))}
      </LoadingDisplayer>
    );
  }
}

GroupsManager.propTypes = {
  simcardGroups: fullListShape.isRequired,
  onAddSimcardGroup: PropTypes.func.isRequired,
  onAddSimcardGroupApn: PropTypes.func.isRequired,
  onDeleteSimcardGroupApn: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  simcardGroups: state.simcardGroup.list,
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withConfirmDialog,
)(GroupsManager);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/groups/GroupsManager.js